import dayjs from 'dayjs'
import {isEmail} from '../../utils'
import {parsePhoneNumber} from 'awesome-phonenumber'
import {AGREEMENT_ESHOP_ID, COUNTRIES, DASHBOARD_TEXTS} from '../helpers/misc'
import App from '../../app/App'


export const normalizePhone = (phoneNumber) => {
  if (!phoneNumber) return ''
  
  // Převést na E.164 formát pokud číslo nezačíná +
  if (!phoneNumber.startsWith('+') && /^\d+$/.test(phoneNumber)) {
    return `+${phoneNumber}`
  }
  
  return phoneNumber
}

export const validateForm = (formData) => {
  const errors = {}
  if(!formData.first_name) errors.first_name = DASHBOARD_TEXTS.validation.firstName
  if(!formData.last_name) errors.last_name = DASHBOARD_TEXTS.validation.lastName
  if(!formData.email) errors.email = DASHBOARD_TEXTS.validation.email
  else if(!isEmail(formData.email)) errors.email = DASHBOARD_TEXTS.validation.emailInvalid
  if(formData.phone) {
    let pn = parsePhoneNumber(formData.phone, {regionCode: 'SK'})
    if(!pn.valid) {
      pn = parsePhoneNumber(formData.phone, {regionCode: 'CZ'})
    }
    if(!pn.valid) {
      pn = parsePhoneNumber(formData.phone)
    }
    if(!pn.valid) {
      errors.phone = DASHBOARD_TEXTS.validation.phoneInvalid
    }
  }
  if(!formData.city) errors.city = DASHBOARD_TEXTS.validation.city
  if(!formData.zip) errors.zip = DASHBOARD_TEXTS.validation.zip
  if(!formData.terms_accepted) errors.terms_accepted = DASHBOARD_TEXTS.validation.terms
  return errors
}

export function getAgreementObject(accepted) {
  let custom_agreements = null
  if(!App.isDevelopment())
    custom_agreements = {
      custom_agreements: [{
        agreement_id: AGREEMENT_ESHOP_ID,
        agreement_value: accepted
      }]
    }

  return {
    agreement_gtc: accepted,
    agreement_profiling: accepted,
    agreement_marketing_communication: accepted,
    ...custom_agreements
  }
}

export function getPersonalInformationObject(formData, originalData = null) {
  const agreementValue = formData.terms_accepted ? 1 : 0
  const country = Object.values(COUNTRIES).find(c => c.code.toLowerCase() === formData.country.toLowerCase())?.code || 'sk'
  const birthdate = formData.birth_date ? dayjs(formData.birth_date, 'DD.MM.YYYY').format('YYYY-MM-DD') : null

  return {
    ...(originalData ? JSON.parse(JSON.stringify(originalData)) : {}),
    language_id: 'sk',
    gender: formData.gender === '' ? null : formData.gender,
    first_name: formData.first_name,
    last_name: formData.last_name,
    email: formData.email,
    phone: formData.phone,
    birthdate: birthdate,

    address: {
      address1: formData.street,
      city: formData.city,
      zip: formData.zip,
      country_code: country
    },
    agreement: getAgreementObject(agreementValue)
  }
}

/** @deprecated
 * MA: TAKHLE SPATNOU FUNKCI JSEM DLOUHO NEVIDEL. Jsou v ni cca 4 chyby ktery znemoznuji spravne nastaveni
 * */
export const prepareUpdateData = (formData, originalData) => {
  let updatedCustomerData = originalData ? JSON.parse(JSON.stringify(originalData)) : {}
  //MA: CO JE TOHLE ZA NAZEV PROMENNY????!!!! V TYHLE FUNKCI MNE TAKOVEJ NAZEV ANI TROSKU NEZAJIMA
  const agreementValue = formData.terms_accepted ? 1 : 0

  //MA: HA TADY BEJVA DOBRY KDYZ country a code jsou stejny parametry. Porovnavani code s name vetsinou nevyjde :D :D :D. ANEB TOHLE SE VZYCKY NASTAVI NA sk
  updatedCustomerData.language_id = Object.values(COUNTRIES).find(c => c.name.toLowerCase() === formData.country.toLowerCase())?.code || 'sk'
  updatedCustomerData.first_name = formData.first_name
  updatedCustomerData.last_name = formData.last_name
  updatedCustomerData.email = formData.email
  updatedCustomerData.phone = formData.phone
  updatedCustomerData.birthdate = formData.birth_date ? dayjs(formData.birth_date, 'DD.MM.YYYY').format('YYYY-MM-DD') : null

  if(updatedCustomerData.address) {
    //MA: CO TO JE ZA PODMINKU????!!!!!!! Chapu spravne ze aktualizujeme pouze ve fazi assigned with mail, jinak ne?
    updatedCustomerData.address.address1 = formData.street
    updatedCustomerData.address.city = formData.city
    updatedCustomerData.address.zip = formData.zip
    const country = Object.values(COUNTRIES).find(c => c.name.toLowerCase() === formData.country.toLowerCase())?.code
    updatedCustomerData.address.country_code = country || 'sk'
  }

  // MA: Tak tuhle podminku chci taky vysvetlit, na to se tesim. Pokud ctu spravne agreeements se posila pouze pokud prochazime variantou assigned_with_mail. Pokud variantou bez emailu souhlasy se nenastavuji i kdyz souhlas zaskrtnout v UI formulare musim. Proc jsi to takhle udelal?
  if(updatedCustomerData.agreement) {
    updatedCustomerData.agreement.agreement_gtc = agreementValue
    updatedCustomerData.agreement.agreement_profiling = agreementValue
    updatedCustomerData.agreement.agreement_marketing_communication = agreementValue
    updatedCustomerData.agreement.custom_agreements = [{
      agreement_id: '84d7313c84b270aa5893770d53',
      agreement_value: agreementValue
    }]
  }

  return updatedCustomerData
}

/** @deprecated */
export const prepareRegistrationData = (formData) => {
  // NENI TOHLE NAHODOU STEJNY JAKO PREPAREUPDATEDATA????!!!!! FUJ
  const agreementValue = formData.terms_accepted ? 1 : 0

  return {
    //MA: Neni tady ten radek kodu stejnej znova o kus niz, ze ne?! Kolikrat budeme vychozi sk nastavovat?
    language_id: Object.values(COUNTRIES).find(c => c.name.toLowerCase() === formData.country.toLowerCase())?.code || 'sk',
    first_name: formData.first_name,
    last_name: formData.last_name,
    email: formData.email,
    phone: (() => {
      let pn = parsePhoneNumber(formData.phone, {regionCode: 'SK'})
      if(!pn.valid) {
        pn = parsePhoneNumber(formData.phone, {regionCode: 'CZ'})
      }
      if(!pn.valid) {
        pn = parsePhoneNumber(formData.phone)
      }
      return pn.valid ? pn.number.e164 : formData.phone
    })(),
    birthdate: formData.birth_date ? dayjs(formData.birth_date, 'DD.MM.YYYY').format('YYYY-MM-DD') : null,
    address: {
      address1: formData.street,
      city: formData.city,
      zip: formData.zip,
      country_code: Object.values(COUNTRIES).find(c => c.name.toLowerCase() === formData.country.toLowerCase())?.code || 'sk'
    },
    agreement: {
      agreement_gtc: agreementValue,
      agreement_profiling: agreementValue,
      agreement_marketing_communication: agreementValue,
      custom_agreements: [{
        agreement_id: '84d7313c84b270aa5893770d53',
        agreement_value: agreementValue
      }]
    }
  }
}
